import { Map as map } from 'immutable';
const C = require("../constants");

function RecipeStockReducer(state = map(), action) {
    switch (action.type) {
        case C.RECIPES_STOCK:
            return action.recipes_stock;
        case C.RECIPES_STOCK_UPDATE:
            return state.map((recipe_stock)=> {
                if(recipe_stock.id === action.recipe_stock.id ) {
                    return action.recipe_stock
                } else {
                    return recipe_stock;
                }
            });
        default:
            return state;
    }
}

export default RecipeStockReducer;


// WEBPACK FOOTER //
// ./src/reducers/RecipeStockReducer.js